import apiClient from '../services/api';

const state = {
  users: [],
};

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
  ADD_USER(state, user) {
    state.users.push(user);
  },
  UPDATE_USER(state, updatedUser) {
    const index = state.users.findIndex(user => user.userId === updatedUser.userId);
    if (index !== -1) {
      state.users.splice(index, 1, updatedUser);
    }
  },
  REMOVE_USER(state, userId) {
    state.users = state.users.filter(user => user.userId !== userId);
  },
};

const actions = {
  async fetchUsers({ commit }) {
    try {
      // The interceptor automatically adds the token and base URL.
      const response = await apiClient.get('/users/by-customer');
      commit('SET_USERS', response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },
  
  async createUser({ dispatch }, userData) {
    try {
      await apiClient.post('/users', userData);
      // After creating, refetch the entire list to ensure the UI is in sync.
      await dispatch('fetchUsers');
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  },

  async updateUser({ dispatch }, { userId, userData }) {
    try {
      await apiClient.put(`/users/${userId}`, userData);
      await dispatch('fetchUsers');
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  },
  
  async deleteUser({ commit }, userId) {
    try {
      await apiClient.delete(`/users/${userId}`);
      // Optimistically remove the user from the local state
      commit('REMOVE_USER', userId);
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};

